// @ts-nocheck

interface PlaceObj {
  sw_lat: number;
  ne_lat: number;
  sw_lng: number;
  ne_lng: number;
}

const getCenterFromRectangle = (place: PlaceObj) => {
  const centerLat = (place.sw_lat + place.ne_lat) / 2;
  const centerLng = (place.sw_lng + place.ne_lng) / 2;

  return { lat: centerLat, lon: centerLng };
};

const getPlaceFromCoords = (lat, lon, setSearchPlaceName, fallback = undefined) => {
  try {
    const latlng = new google.maps.LatLng(lat, lon);
    new google.maps.Geocoder().geocode({ latLng: latlng }, function (results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        if (results[1]) {
          let country = null;
          let countryCode = null;
          let city = null;
          let cityAlt = null;
          let c, lc, component;
          for (let r = 0, rl = results.length; r < rl; r += 1) {
            const result = results[r];

            if (!city && result.types[0] === 'locality') {
              for (c = 0, lc = result.address_components.length; c < lc; c += 1) {
                component = result.address_components[c];

                if (component.types[0] === 'locality') {
                  city = component.long_name;
                  break;
                }
              }
            } else if (!city && !cityAlt && result.types[0] === 'administrative_area_level_1') {
              for (c = 0, lc = result.address_components.length; c < lc; c += 1) {
                component = result.address_components[c];

                if (component.types[0] === 'administrative_area_level_1') {
                  cityAlt = component.long_name;
                  break;
                }
              }
            } else if (!country && result.types[0] === 'country') {
              country = result.address_components[0].long_name;
              countryCode = result.address_components[0].short_name;
            }

            if (city && country) {
              break;
            }
          }

          if (city && country) {
            setSearchPlaceName(`${city || ''}, ${country || ''}`);
          } else if (city) {
            setSearchPlaceName(city);
          } else if (country) {
            setSearchPlaceName(country);
          } else {
            setSearchPlaceName(fallback);
          }
        } else {
          setSearchPlaceName(fallback);
        }
      }
    });
  } catch (e) {
    console.error('GET PLACE NAME ERROR', e);
  }
};

export { getCenterFromRectangle, getPlaceFromCoords };
